export default __webpack_public_path__ + "static/media/LINK-ETH.e86de6c1.png";